/* ==========================================================================
   SearcherBusHotel > Config
   ========================================================================== */

/* Modules */
const panelConfig = require('../../../ui-panel-passenger-bus/client/js/config');

/* Configuration */
const configuration = {
    selector: '[data-component="SearcherBusHotel"]',
    type: {
        select: 'select',
        autocomplete: 'autocomplete',
        calendar: 'calendar',
        uipanel: {
            trigger: 'ui-panel-passenger-bus-trigger',
            panel: panelConfig().type.panel
        },
        submit: 'submit'
    },
    css: {
        item: 'searcher__item',
        itemLarge: 'searcher__item--large',
        itemSmall: 'searcher__item--small',
        itemButton: 'searcher__item--button',
        button: 'searcher__button'
    },
    accommodationPanel: {
        css: 'ui-panel--accommodation-packages',
        type: 'ui-panel-passenger-bus-hotel',
        selector: '[data-component="UiPanel"][data-type="ui-panel-passenger-bus-hotel"]',
        hasClose: true,
        maxRooms: 4,
        adults: {
            min: 1,
            max: 6,
            value: 2
        },
        children: {
            min: 0,
            max: 5,
            value: 0,
            ages: {
                min: 0,
                max: 17
            }
        }
    },
    accommodationPlayasPanel: {
        css: 'ui-panel--accommodation-packages',
        type: 'ui-panel-passenger-bus-playas-hotel',
        selector: '[data-component="UiPanel"][data-type="ui-panel-passenger-bus-playas-hotel"]',
        hasClose: true,
        maxRooms: 4,
        adults: {
            min: 1,
            max: 6,
            value: 2
        },
        children: {
            min: 0,
            max: 5,
            value: 0,
            ages: {
                min: 0,
                max: 17
            }
        }
    },
    accommodationModelPanel: {
        css: 'ui-panel--accommodation-packages',
        type: 'ui-panel-passenger-bus-model-hotel',
        selector: '[data-component="UiPanel"][data-type="ui-panel-passenger-bus-model-hotel"]',
        hasClose: true,
        maxRooms: 4,
        adults: {
            min: 1,
            max: 6,
            value: 2
        },
        children: {
            min: 0,
            max: 5,
            value: 0,
            ages: {
                min: 0,
                max: 17
            }
        }
    },
    accommodationTrigger: {
        type: 'input-passenger-bus-hotel-trigger',
        selector: '[data-component="Input"][data-type="input-passenger-bus-hotel-trigger"]',
        icon: 'user'
    },
    accommodationPlayasTrigger: {
        type: 'input-passenger-playas-trigger',
        selector: '[data-component="Input"][data-type="input-passenger-playas-trigger"]',
        icon: 'user'
    },
    accommodationModelTrigger: {
        type: 'input-passenger-bus-hotel-model-trigger',
        selector: '[data-component="Input"][data-type="input-passenger-bus-hotel-model-trigger"]',
        icon: 'user'
    },
    submit: {
        url: '/packagesasyncsp/AvailabilityMaterial'
    },
    submitBanner: {
        target: '_blank',
        url: 'https://www.alsaviajes.com/packagesasyncsp/AvailabilityMaterial'
    },
    image: {
        cdn: '//cdn.logitravel.com',
        src: '/contenidos/fotos/CIUDADES/##code##.jpg',
        alternative: '/comun/images/lineas/buses_800x600.jpg',
        resize: '/wsimgresize/resize/crop/334/260/',
        quality: '80'
    },
    getStyle: element => configuration[element].css,
    operativeUrl: '/flightsshowcase/Operative/GetBusDestinationsByOrigin'
};

const config = () => configuration;

module.exports = config;
